module.exports = __webpack_public_path__ + "img/8_wgoods.4eae0fe7.jpg";